module.exports = __webpack_public_path__ + "img/translator__ru-en.29970d7.svg";